import React from 'react';

const PreLoader = () =>{
   return( <>
        <div className='preloader-css'><img src={require("../img/red-preloader.gif")} alt='loader' /></div>
    </>
   );
}

export default PreLoader;